import Node from './Node';

function updateProtocol(host: string): string {
  const insecure = host.startsWith('http:');
  const updatedHost = host.replace(/^\w+:\/\//, '');
  // if the host started with http, us ws. This helps local dev.
  return `${insecure ? 'ws' : 'wss'}://${updatedHost}`;
}

export default function buildWSURL(
  host: string,
  path: string,
  node: Node,
  token: string
): string {
  const base = /^wss?:\/\//.test(host) ? host : updateProtocol(host);
  const url = new URL(path, base);
  url.searchParams.append('access_token', token);
  url.searchParams.append('nodeId', node.nodeId);
  url.searchParams.append('agentId', node.agentId);
  url.searchParams.append('tenantId', node.tenantId);
  url.searchParams.append('contentId', node.contentId);
  return url.toString();
}
